import {useState} from "react";

import {TwilioConnect} from "./TwilioConnect";
import {PHONE_NUMBER_ASSIGNMENT_OPTIONS} from "../../../data";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export const QuickAssistantSetupPhoneNumberSection = () => {
  // INFO: this UX depends on whether phone number is available or not.

  // TODO(maybe): create `PhoneNumberBuyOrSelect` component in phone numbers module
  // and use here.
  const phoneNumberAvailable = false;

  const [option, setOption] = useState<"twilio" | "buy" | null>(null);

  if (phoneNumberAvailable) {
    return <div>select phone number</div>;
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-4">
        {PHONE_NUMBER_ASSIGNMENT_OPTIONS.map(option => (
          <Card
            key={option.key}
            className="flex-1 cursor-pointer hover:shadow-md"
            onClick={() => setOption(option.key)}
          >
            <CardHeader>
              {option.icon}
              <CardTitle>{option.title}</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription>{option.description}</CardDescription>
            </CardContent>
          </Card>
        ))}
      </div>

      {option === "twilio" && (
        <div>
          <TwilioConnect />
        </div>
      )}

      {/* TODO: buy phone number modal if option is "buy" */}
    </div>
  );
};
